import { Link } from "react-router-dom";
import PageWrapper from "../components/PageWrapper";
import usePageMeta from "../hooks/usePageMeta";
import { pageTitle } from "../lib/seo";

/* Shown for unknown URLs. The static host still answers 200, so the noindex
   tag is what keeps these "soft 404" pages out of Google's index. */
function NotFound() {
  usePageMeta({
    title: pageTitle("Page not found"),
    description: "The page you were looking for doesn't exist.",
    noindex: true,
  });

  return (
    <PageWrapper>
      <div className="container section">
        <h1 className="h1">Page not found</h1>
        <p className="lead" style={{ marginTop: 10 }}>
          The page you were looking for doesn't exist or has moved.
        </p>
        <div style={{ marginTop: 18, display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link className="btn btn-primary" to="/packages/">Browse holiday packages</Link>
          <Link className="btn btn-ghost" to="/visa/">Visa services</Link>
          <Link className="btn btn-ghost" to="/">Home</Link>
        </div>
      </div>
    </PageWrapper>
  );
}

export default NotFound;
